"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerActionResult = exports.RoundState = exports.PileId = exports.CardDisclosureStatus = exports.CardType = exports.CardSuit = void 0;
var CardSuit;
(function (CardSuit) {
    CardSuit[CardSuit["Club"] = 0] = "Club";
    CardSuit[CardSuit["Spade"] = 1] = "Spade";
    CardSuit[CardSuit["Heart"] = 2] = "Heart";
    CardSuit[CardSuit["Diamond"] = 3] = "Diamond";
    CardSuit[CardSuit["Wild"] = 4] = "Wild";
})(CardSuit || (exports.CardSuit = CardSuit = {}));
var CardType;
(function (CardType) {
    CardType[CardType["Ace"] = 1] = "Ace";
    CardType[CardType["Two"] = 2] = "Two";
    CardType[CardType["Three"] = 3] = "Three";
    CardType[CardType["Four"] = 4] = "Four";
    CardType[CardType["Five"] = 5] = "Five";
    CardType[CardType["Six"] = 6] = "Six";
    CardType[CardType["Seven"] = 7] = "Seven";
    CardType[CardType["Eight"] = 8] = "Eight";
    CardType[CardType["Nine"] = 9] = "Nine";
    CardType[CardType["Ten"] = 10] = "Ten";
    CardType[CardType["Jack"] = 11] = "Jack";
    CardType[CardType["Queen"] = 12] = "Queen";
    CardType[CardType["King"] = 13] = "King";
    CardType[CardType["Joker1"] = 52] = "Joker1";
    CardType[CardType["Joker2"] = 53] = "Joker2";
})(CardType || (exports.CardType = CardType = {}));
var CardDisclosureStatus;
(function (CardDisclosureStatus) {
    CardDisclosureStatus[CardDisclosureStatus["None"] = 0] = "None";
    CardDisclosureStatus[CardDisclosureStatus["Pending"] = 1] = "Pending";
    CardDisclosureStatus[CardDisclosureStatus["InProgress"] = 2] = "InProgress";
    CardDisclosureStatus[CardDisclosureStatus["Completed"] = 3] = "Completed";
})(CardDisclosureStatus || (exports.CardDisclosureStatus = CardDisclosureStatus = {}));
var PileId;
(function (PileId) {
    PileId[PileId["Deck"] = 0] = "Deck";
    PileId[PileId["Column1"] = 1] = "Column1";
    PileId[PileId["Column2"] = 2] = "Column2";
    PileId[PileId["Column3"] = 3] = "Column3";
    PileId[PileId["Column4"] = 4] = "Column4";
    PileId[PileId["CardStackCurrent"] = 5] = "CardStackCurrent";
    PileId[PileId["CardStackNext"] = 6] = "CardStackNext";
    PileId[PileId["Waste"] = 7] = "Waste";
})(PileId || (exports.PileId = PileId = {}));
var RoundState;
(function (RoundState) {
    RoundState[RoundState["Loading"] = 0] = "Loading";
    RoundState[RoundState["Deal"] = 1] = "Deal";
    RoundState[RoundState["Dealing"] = 2] = "Dealing";
    RoundState[RoundState["Play"] = 3] = "Play";
    RoundState[RoundState["Transition"] = 4] = "Transition";
    RoundState[RoundState["Result"] = 5] = "Result";
    RoundState[RoundState["Finish"] = 6] = "Finish";
})(RoundState || (exports.RoundState = RoundState = {}));
var PlayerActionResult;
(function (PlayerActionResult) {
    PlayerActionResult[PlayerActionResult["Stack"] = 0] = "Stack";
    PlayerActionResult[PlayerActionResult["Bust"] = 1] = "Bust";
    PlayerActionResult[PlayerActionResult["ReachedTarget"] = 2] = "ReachedTarget";
    PlayerActionResult[PlayerActionResult["Wild"] = 3] = "Wild";
})(PlayerActionResult || (exports.PlayerActionResult = PlayerActionResult = {}));
